import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../../lib/utils";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Inner padding preset. */
  padding?: "none" | "sm" | "md" | "lg";
}

const PADDING = {
  none: "",
  sm: "p-3",
  md: "p-4",
  lg: "p-6",
} as const;

/** Rounded surface card with a hairline border and soft shadow. */
export function Card({ children, padding = "md", className, ...rest }: CardProps) {
  return (
    <div className={cn("card-surface", PADDING[padding], className)} {...rest}>
      {children}
    </div>
  );
}

export default Card;
